import { Component, Input, OnInit } from '@angular/core';
import { VulnerabilitySummary, VulnerabilitySeverity } from '../service/index';
import { TranslateService } from '@ngx-translate/core';

import { VULNERABILITY_SCAN_STATUS } from '../utils';

export const MIN_TIP_WIDTH = 5;
export const MAX_TIP_WIDTH = 100;

@Component({
    selector: 'hbr-vulnerability-summary-chart',
    template: `<div class="tip-wrapper tip-position" [style.width]='maxWidth'>
    <clr-tooltip>
        <div clrTooltipTrigger>
        <div class="tip-wrapper tip-block bar-block-high" [style.width]='tipWidth(5)'></div>
        <div class="tip-wrapper tip-block bar-block-medium" [style.width]='tipWidth(4)'></div>
        <div class="tip-wrapper tip-block bar-block-low" [style.width]='tipWidth(3)'></div>
        <div class="tip-wrapper tip-block bar-block-unknown" [style.width]='tipWidth(2)'></div>
        <div class="tip-wrapper tip-block bar-block-none" [style.width]='tipWidth(1)'></div>
        </div>
        <clr-tooltip-content [clrPosition]="'top-right'" [clrSize]="'lg'" *clrIfOpen>
            <div [ngSwitch]="scanLevel" class="bar-tooltip-font-larger">
                <ng-template [ngSwitchCase]="5">
                    <clr-icon shape="exclamation-circle" class="is-error" size="32"></clr-icon>
                    <span>{{'VULNERABILITY.OVERALL_SEVERITY' | translate }} <span class="font-weight-600">{{'VULNERABILITY.SEVERITY.HIGH' | translate | titlecase }}</span></span>
                </ng-template>
                <ng-template [ngSwitchCase]="4">
                    <clr-icon *ngIf="hasMedium" shape="exclamation-triangle" class="tip-icon-medium" size="30"></clr-icon>
                    <span>{{'VULNERABILITY.OVERALL_SEVERITY' | translate }} <span class="font-weight-600">{{'VULNERABILITY.SEVERITY.MEDIUM' | translate | titlecase}}</span></span>
                </ng-template>
                <ng-template [ngSwitchCase]="3">
                    <clr-icon shape="play" class="tip-icon-low rotate-90" size="28"></clr-icon>
                    <span>{{'VULNERABILITY.OVERALL_SEVERITY' | translate }} <span class="font-weight-600">{{'VULNERABILITY.SEVERITY.LOW' | translate | titlecase }}</span></span>
                </ng-template>
                <ng-template [ngSwitchCase]="2">
                    <clr-icon shape="help" size="24" style="margin-left: 3px;"></clr-icon>
                    <span>{{'VULNERABILITY.OVERALL_SEVERITY' | translate }} <span class="font-weight-600">{{'VULNERABILITY.SEVERITY.UNKNOWN' | translate | titlecase }}</span></span>
                </ng-template>
                <ng-template [ngSwitchCase]="1">
                    <clr-icon shape="check-circle"  class="is-success" size="32"></clr-icon>
                    <span>{{'VULNERABILITY.NO_VULNERABILITY' | translate }}</span>
                </ng-template>
            </div>
            <hr>
            <div>
                <span class="bar-tooltip-font bar-tooltip-font-title">{{tipTitle}}</span>
            </div>
            <div class="bar-summary bar-tooltip-fon">
                <div *ngIf="hasHigh" class="bar-summary-item">
                    <span><clr-icon shape="exclamation-circle" class="is-error" size="24"></clr-icon></span>
                    <span>{{highCount}}</span><span>{{'VULNERABILITY.SEVERITY.HIGH' | translate }}</span>
                </div>
                <div *ngIf="hasMedium" class="bar-summary-item">
                    <span><clr-icon *ngIf="hasMedium" shape="exclamation-triangle" class="tip-icon-medium" size="22"></clr-icon></span>
                    <span>{{mediumCount}}</span><span>{{'VULNERABILITY.SEVERITY.MEDIUM' | translate }}</span>
                </div>
                <div *ngIf="hasLow" class="bar-summary-item">
                    <span><clr-icon shape="play" class="tip-icon-low rotate-90" size="20"></clr-icon></span>
                    <span>{{lowCount}}</span><span>{{'VULNERABILITY.SEVERITY.LOW' | translate }}</span>
                </div>
                <div *ngIf="hasUnknown" class="bar-summary-item">
                    <span><clr-icon shape="help" size="18"></clr-icon></span>
                    <span>{{unknownCount}}</span><span>{{'VULNERABILITY.SEVERITY.UNKNOWN' | translate }}</span>
                </div>
                <div *ngIf="hasNone" class="bar-summary-item">
                    <span><clr-icon shape="check-circle" class="is-success" size="24"></clr-icon></span>
                    <span>{{noneCount}}</span><span>{{'VULNERABILITY.SEVERITY.NONE' | translate }}</span>
                </div>
            </div>
            <div>
                <span class="bar-scanning-time">{{'VULNERABILITY.CHART.SCANNING_TIME' | translate}} </span>
                <span>{{completeTimestamp | date:'MM/dd/y HH:mm:ss'}}</span>
            </div>
        </clr-tooltip-content>
    </clr-tooltip>
</div>`,
    styles: [`.bar-wrapper{width:120px;height:12px}.bar-state{text-align:center!important}.bar-state-chart{margin-top:2px}.bar-state-error{position:relative;top:-4px}.error-text{position:relative;top:1px;margin-left:-5px;cursor:pointer}.scanning-button{height:24px;margin-top:0;margin-bottom:0;vertical-align:middle;top:-12px;position:relative}.tip-wrapper{display:inline-block;height:10px;max-width:120px}.tip-position{margin-left:-4px}.tip-block{margin-left:-3px}.bar-block-high{background-color:#e62700}.bar-block-medium{background-color:orange}.bar-block-low{background-color:#ff0}.bar-block-none{background-color:green}.bar-block-unknown{background-color:grey}.bar-tooltip-font{font-size:13px;color:#fff}.bar-tooltip-font-title{font-weight:600}.bar-summary{margin-top:12px;text-align:left}.bar-scanning-time{margin-top:12px}.bar-summary-item{margin-top:3px;margin-bottom:3px}.bar-summary-item span:nth-child(1){width:30px;text-align:center;display:inline-block}.bar-summary-item span:nth-child(2){width:28px;display:inline-block}.option-right{padding-right:16px}.refresh-btn{cursor:pointer}.refresh-btn:hover{color:#007cbb}.label.label-medium{background-color:#ffe4a9;border:1px solid orange;color:orange}.tip-icon-medium{color:orange}.label.label-low{background:rgba(251,255,0,.38);color:#c5c50b;border:1px solid #e6e63f}.tip-icon-low{color:#ff0}.font-color-green{color:green}.bar-tooltip-font-larger span{font-size:16px;vertical-align:middle}hr{border-bottom:0;border-color:#aaa;margin:6px -10px}.font-weight-600{font-weight:600}.rightPos{position:absolute;z-index:100;right:35px;margin-top:4px}`]
})
export class ResultTipComponent implements OnInit {
    _tipTitle: string = "";
    _highCount: number = 0;
    _mediumCount: number = 0;
    _lowCount: number = 0;
    _unknownCount: number = 0;
    _noneCount: number = 0;

    totalPackages: number = 0;
    packagesWithVul: number = 0;

    @Input() summary: VulnerabilitySummary = {
        scan_status: VULNERABILITY_SCAN_STATUS.unknown,
        severity: VulnerabilitySeverity.UNKNOWN,
        update_time: new Date(),
        components: {
            total: 0,
            summary: []
        }
    };

    get scanLevel(){
        let level;
        if (this._highCount && this._highCount >= 1) {
            level = VulnerabilitySeverity.HIGH;
        }else if (this._mediumCount && this._mediumCount >= 1) {
            level =  VulnerabilitySeverity.MEDIUM;
        }else if (this._lowCount && this._lowCount >= 1) {
            level = VulnerabilitySeverity.LOW;
        }else if (this._unknownCount && this._unknownCount >= 1) {
            level = VulnerabilitySeverity.UNKNOWN;
        }else if (this.totalPackages === 0) {
             level = VulnerabilitySeverity.UNKNOWN;
        } else {
            level = VulnerabilitySeverity.NONE;
        }
        return level;
    }

    constructor(private translate: TranslateService) { }

    ngOnInit(): void {
        this.totalPackages = this.summary && this.summary.components ? this.summary.components.total : 0;
        if (this.summary && this.summary.components && this.summary.components.summary) {
            this.summary.components.summary.forEach(item => {
                if (item.severity !== VulnerabilitySeverity.NONE) {
                    this.packagesWithVul += item.count;
                }
                switch (item.severity) {
                    case VulnerabilitySeverity.UNKNOWN:
                        this._unknownCount += item.count;
                        break;
                    case VulnerabilitySeverity.NONE:
                        this._noneCount += item.count;
                        break;
                    case VulnerabilitySeverity.LOW:
                        this._lowCount += item.count;
                        break;
                    case VulnerabilitySeverity.MEDIUM:
                        this._mediumCount += item.count;
                        break;
                    case VulnerabilitySeverity.HIGH:
                        this._highCount += item.count;
                        break;
                    default:
                        break;
                }
            });
        }
        this.translate.get(this.packageText(this.totalPackages)).subscribe((p1: string) => {
            this.translate.get(this.unitText(this.packagesWithVul)).subscribe((vul: string) => {
                if (this.totalPackages === 0) {
                    this.translate.get('VULNERABILITY.CHART.TOOLTIPS_TITLE_ZERO').subscribe( (res: string) => {
                        this._tipTitle = res;
                    });
                } else {
                    let messageKey = 'VULNERABILITY.CHART.TOOLTIPS_TITLE_SINGULAR';
                    if (this.packagesWithVul > 1) {
                        messageKey = 'VULNERABILITY.CHART.TOOLTIPS_TITLE';
                    }
                    this.translate.get(messageKey, {
                        totalVulnerability: this.packagesWithVul,
                        totalPackages: this.totalPackages,
                        package: p1,
                        vulnerability: vul
                    }).subscribe((res: string) => this._tipTitle = res);
                }
            });
        });
    }

    tipWidth(severity: VulnerabilitySeverity): string {
        let n: number = 0;
        let m: number = this.totalPackages;

        if (m === 0) {
            // If no packages recognized, then show grey
            if (severity === VulnerabilitySeverity.UNKNOWN) {
                return MAX_TIP_WIDTH + 'px';
            } else {
                return 0 + 'px';
            }
        }

        switch (severity) {
            case VulnerabilitySeverity.HIGH:
                n = this.highCount;
                break;
            case VulnerabilitySeverity.MEDIUM:
                n = this.mediumCount;
                break;
            case VulnerabilitySeverity.LOW:
                n = this.lowCount;
                break;
            case VulnerabilitySeverity.UNKNOWN:
                n = this.unknownCount;
                break;
            case VulnerabilitySeverity.NONE:
                // Show all the left as green bar
                n = m - (this.highCount + this.mediumCount + this.lowCount + this.unknownCount);
                if (n < 0) { n = 0; }
                break;
            default:
                n = 0;
                break;
        }

        let width: number = Math.round((n / m) * MAX_TIP_WIDTH);
        if (width > 0 && width < MIN_TIP_WIDTH) {
            width = MIN_TIP_WIDTH;
        }

        return width + 'px';
    }


    unitText(count: number): string {
        if (count > 1) {
            return "VULNERABILITY.PLURAL";
        }

        return "VULNERABILITY.SINGULAR";
    }

    packageText(count: number): string {
        return count > 1 ? "VULNERABILITY.PACKAGES" : "VULNERABILITY.PACKAGE";
    }

    public get completeTimestamp(): Date {
        return this.summary && this.summary.update_time ? this.summary.update_time : new Date();
    }

    public get hasHigh(): boolean {
        return this.highCount > 0;
    }

    public get hasMedium(): boolean {
        return this.mediumCount > 0;
    }

    public get hasLow(): boolean {
        return this.lowCount > 0;
    }

    public get hasUnknown(): boolean {
        return this.unknownCount > 0;
    }

    public get hasNone(): boolean {
        return this.noneCount > 0;
    }

    public get tipTitle(): string {
        return this._tipTitle;
    }

    public get highCount(): number {
        return this._highCount;
    }

    public get mediumCount(): number {
        return this._mediumCount;
    }

    public get lowCount(): number {
        return this._lowCount;
    }

    public get unknownCount(): number {
        return this._unknownCount;
    }
    public get noneCount(): number {
        return this._noneCount;
    }

    public get highSuffix(): string {
        return this.unitText(this.highCount);
    }

    public get mediumSuffix(): string {
        return this.unitText(this.mediumCount);
    }

    public get lowSuffix(): string {
        return this.unitText(this.lowCount);
    }

    public get unknownSuffix(): string {
        return this.unitText(this.unknownCount);
    }

    public get noneSuffix(): string {
        return this.unitText(this.noneCount);
    }

    public get maxWidth(): string {
        return (MAX_TIP_WIDTH + 20) + "px";
    }
}
